import { icon, node } from "~/util/dom";
import ContentOverlay from "~/content.overlay";
import { ICONS } from "./svgicons";

const PATH_FILL_BLACK: Array<string> = [
	"arrows-left",
	"arrows-right",
	"note-right-corner",
	"pointer-arrow-pubt",
	"traffic",
	"warn",
	"warn-filled",
];
const PATH_FILL_WHITE: Array<string> = [
	"email",
	"facebook",
	"traffic",
];

export default class AllIconsContent extends ContentOverlay {
	_keys: Array<string> = [];

	constructor() {
		super();

		this._contentName = "all-icons";
		this._dom = {
			container: node("div", { id: "allIcons" }),
			list: node("div", { className: "allIcons__list" }),
			input: node("input", { type: "text", placeholder: "Název", className: "allIcons__queryInput" }),
		};
		this._keys = Object.keys(ICONS);
		this._keys.sort((aItem, bItem) => aItem.localeCompare(bItem));

		this._dom.input.addEventListener("input", event => {
			this._fillList(event.target.value);
		});

		this._buildCloseButton();
	}

	activate() {
		const thisSuper = super.activate();

		this._myBuild();
		this._fillList();

		return thisSuper;
	}

	_myBuild() {
		this._dom.container.innerHTML = "";

		this._dom.container.append(
			node("h2", { textContent: "Seznam SVG ikon" }),
			node("p", { textContent: "Kliknutím na ikonu se název uloží do schránky" }),
			this._dom.input,
			this._dom.list,
		);
	}

	_fillList(query = "") {
		this._dom.list.innerHTML = "";

		const docFragment = document.createDocumentFragment();
		const curKeys = this._keys.slice().filter(key => !query || (query && key.toLowerCase().indexOf(query.toLowerCase())) !== -1);

		for (const iconKey of curKeys) {
			const fillPathBlack = PATH_FILL_BLACK.includes(iconKey);
			const fillPathWhite = !fillPathBlack && PATH_FILL_WHITE.includes(iconKey);
			const className = ["allIcons__item"];

			if (fillPathBlack) {
				className.push("fill-svg-path-black");
			} else if (fillPathWhite) {
				className.push("fill-svg-path-white");
			} else {
				className.push("fill-svg");
			}

			const iconEl = node("span", { className: `allIcons__item ${className.join(" ")}` });
			const iconTitle = node("span", { className: "allIcons__itemTitle", textContent: iconKey });

			iconEl.title = iconKey;
			iconEl.append(icon(iconKey), iconTitle);
			docFragment.append(iconEl);
			iconEl.addEventListener("click", () => {
				navigator.clipboard.writeText(iconKey);
			});
		}

		this._dom.list.append(docFragment);
	}
}
